
import { AlertCircleIcon } from 'vue-feather-icons';
import { mapState } from 'vuex';
import { PaymentMethods } from '@/services/payments/PaymentMethods';
import cartMixin from '@/mixins/cartMixin';
export default {
  name: 'CheckoutPayment',
  mixins: [cartMixin],
  components: {
    AlertCircleIcon,
  },
  data() {
    return {
      paymentService: new PaymentMethods({ http: this.$http }),
      paymentMethods: [],
      reload: 0,
      ip: null,
    };
  },
  computed: {
    ...mapState('checkout', [
      'shippingType',
      'shippingAddress',
      'invoiceAddress',
      'checkoutCarrier',
      'checkoutRelayPoint',
      'refreshPaymentMethods',
      'submittingPayment',
    ]),

    cartTotalToPay() {
      return this.cart?.Total?.ToPay?.TaxIncl;
    },

    validate() {
      return true;
    },
  },
  methods: {
    async getPaymentMethods() {
      if (this.submittingPayment) return;
      if (this._paymentTimer) clearTimeout(this._paymentTimer);
      this._paymentTimer = setTimeout(async () => {
        try {
          if (!this.ip) this.ip = await this.getIp();
          let options = { languageIsoCode: this.$i18n.locale };

          const addr = this.shippingAddress;
          if (addr?.Address1 && addr?.Postcode && addr?.CountryIsoCode) {
            Object.assign(options, {
              postcode: addr.Postcode,
              city: addr.City,
              address1: addr.Address1,
              country: addr.Country || addr.CountryIsoCode,
              countryIsoCode: addr.CountryIsoCode,
            });
          } else if (this.ip) {
            options.ip = this.ip;
          }

          const response = await this.paymentService.list(options);
          this.$store.commit('checkout/setPaymentMethods', {
            data: response?.PaymentMethods || [],
          });
        } catch (err) {
          console.error('Failed to load payment methods', err);
        }
      }, 300);
    },
    async getIp() {
      try {
        const res = await this.$store.dispatch(
          'shop/localisation/fetchVisitor'
        );
        return res.ip;
      } catch (e) {
        return null;
      }
    },
  },

  watch: {
    validate: {
      handler(val) {
        if (val) this.getPaymentMethods();
      },
      immediate: true,
    },
    shippingAddress: {
      handler(val) {
        if (val) this.getPaymentMethods();
      },
      deep: true,
    },
    cart: {
      handler() {
        this.reload++;
      },
      deep: true,
    },
  },
  beforeDestroy() {
    if (this._paymentTimer) clearTimeout(this._paymentTimer);
  },
};
